module.exports = __webpack_public_path__ + "img/9791167850492.9667a6b1.jpg";